import api from '@/api'
import scrollReveal from "scrollreveal";

export default {
  install (Vue) {
    Vue.prototype.$api = api
    Vue.prototype.$scrollReveal = scrollReveal
  }
}
